module.exports = __webpack_public_path__ + "img/LAPTOP.afb4cce2.svg";